module.exports = __webpack_public_path__ + "h5/img/course-icon.d742161a.png";